<template>
  <form-capsule :formTitle="$t('verifications.verification_title')">
    <template slot="formcontent">
      <div class="col-md-12" style="display:inline-flex;">
        <div id="formBlock" class="col-md-6">
          <div class="row">
            <form-write-group-label-input :isMandatory="true"
              :idLabel="$t('verifications.lblSIREN')"
              :placeholderValue="$t('verifications.placeHSIREN')"
              v-model="siren" :mandatoryErrorIndicator="sirenError"
              :regexpErrorIndicator="sirenRegexpError">
            </form-write-group-label-input>
          </div>
          <div class="row">
            <form-write-group-label-input :isMandatory="true"
              :idLabel="$t('verifications.select_type')"
              :inputType="'listeSelect'">
              <select class="form-control" id="selectVerifications" readonly v-model="verifTypeSelected"
                @change="checkVerifType" :mandatoryErrorIndicator="verifTypeSelectedError">
                <option value="">{{ $t('verifications.choose_type') }}</option>
                <option v-for="verifType in typeListVerification" :key="verifType.id"
                  :value="$t(verifType.typeValue)"
                  :disabled="verifType.disabled"
                  :style="verifType.disabled ? 'font-style:italic;' : ''">
                  {{ $t(verifType.typeLabel) }}
                </option>
              </select>
            </form-write-group-label-input>
          </div>
        </div>
        <div id="resultBlock" class="col-md-6 displayResultVerif verifHidden">
          <div class="row">
            <ul class="col-md-11">
              <li id="SIREN" class="verifHidden">
                <span class="lblVerifications lblSIREN">{{ $t('verifications.result_verification') }}</span>
                <span class="resultVerifications" id="resultSIREN"></span>
              </li>
            </ul>
          </div>
          <div class="row">
            <ul class="col-md-11">
              <li id="LegalStatus" class="verifHidden">
                <span class="lblVerifications lblLegalStatus">{{ $t('verifications.legal_status') }}</span>
                <span class="resultVerifications" id="resultLegalStatus"></span>
              </li>
              <li id="LegalKind" class="verifHidden">
                <span class="lblVerifications lblLegalKind">{{ $t('verifications.legal_kind') }}</span>
                <span class="resultVerifications" id="resultLegalKind"></span>
              </li>
              <li id="LegalChief" class="verifHidden">
                <span class="lblVerifications lblLegalChief">{{ $t('verifications.legal_Chief') }}</span>
                <span class="resultVerifications" id="resultLegalChief"></span>
              </li>
              <li id="LegalKbis" class="verifHidden">
                <span class="lblVerifications lblLegalKbis">{{ $t('verifications.legal_kbis') }}</span>
                <span class="resultVerifications" id="resultLegalKbis"></span>
              </li>
              <li id="LegalStatut" class="verifHidden">
                <span class="lblVerifications lblLegalStatut">{{ $t('verifications.legal_statut') }}</span>
                <span class="resultVerifications" id="result_LegalStatut"></span>
              </li>
              <li id="LegalBenificiary" class="verifHidden">
                <span class="lblVerifications lblLegalBenificiary">{{ $t('verifications.legal_benificiary') }}</span>
                <span class="resultVerifications" id="result_LegalBenificiary"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template slot="footerbuttons">
      <div class="row justify-content-start">
        <div class="col-md-3 offset-md-8">
          <button round
            class="button-action firstButtonMarginTop col-md milkyBlockBlack"
            @click="verificationSend">
            <i class="icon icon-verifications-white"></i>
            {{ $t('verifications.btnSubVerification') }}
          </button>
        </div>
      </div>
    </template>
  </form-capsule>
</template>
<script>

import formCapsule from '@/components/common/formCapsule.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'
  /** @author TLV - JPR 06/11/2020
  * @brief Component for adding Suppliers
  */
export default {
  name: 'verificationsForm',
  components: {
    'form-capsule': formCapsule,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      siren: '',
      verifTypeSelected: '',
      verifTypeSelectedError: false,
      typeListVerification: [
        { 'id': 1, 'typeValue': 'Siren', 'typeLabel': 'verifications.slct_doct_type', 'disabled': false },
        { 'id': 2, 'typeValue': 'Kbis', 'typeLabel': 'verifications.KBIS', 'disabled': false },
        { 'id': 3, 'typeValue': 'Actes', 'typeLabel': 'verifications.ACTES', 'disabled': false },
        { 'id': 4, 'typeValue': 'Ubo', 'typeLabel': 'verifications.UBO', 'disabled': false }
      ],
      sirenError: false,
      sirenRegexpError: false
    }
  },
  created () {
    console.log(this.typeListVerification)
  },
  methods: {
    validateForm () {
      let flagsList = {}
      let mandatoryValues = ['siren']
      let regexpValues = {
        'siren': 'SIREN'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    verificationSend () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.verification_loader'))
      let that = this
      /*
      * target to show hide
      */
      // let tabGblResult = ['#resultSIREN', '#resultLegalStatus', '#resultLegalKind', '#resultLegalChief', '#resultLegalKbis', '#resultLegalStatut', '#resultLegalBeneficiary']
      let tabGblTargetBlock = ['#resultBlock', '#SIREN', '#LegalStatus', '#LegalKind', '#LegalChief', '#LegalKbis', '#LegalStatut', '#LegalBenificiary']
      switch (that.verifTypeSelected) {
        case 'Siren':
          that.$engine.services.verifications.SIREN({'Siren': that.siren})
            .then(response => {
              that.status = response.status
              if (response.status === 200) {
                that.$f7.hidePreloader()
                let tabTarget = ['#resultBlock', '#SIREN', '#LegalStatus', '#LegalKind', '#LegalChief']
                // let tabResult = ['#resultSIREN', '#resultLegalStatus', '#resultLegalKind', '#resultLegalChief']
                for (var key in tabGblTargetBlock) {
                  let item = that.$$(tabGblTargetBlock[key])
                  if (!item.hasClass('verifHidden')) {
                    item.addClass('verifHidden')
                  }
                }
                for (var tkey in tabTarget) {
                  let titem = that.$$(tabTarget[tkey])
                  if (titem.hasClass('verifHidden')) {
                    titem.removeClass('verifHidden')
                  }
                }
                console.log(response.data)
              }
            })
            .catch(error => {
              that.$f7.hidePreloader()
              for (var key in tabGblTargetBlock) {
                let item = that.$$(tabGblTargetBlock[key])
                if (!item.hasClass('verifHidden')) {
                  item.addClass('verifHidden')
                }
              }
              errorMessageAlert(error, that)
            })
          break
        case 'Kbis':
          that.$engine.services.verifications.KBIS({'Kbis': that.kbis})
          .then(response => {
            that.status = response.status
            if (response.status === 200) {
              that.$f7.hidePreloader()
              let tabTarget = ['#resultBlock', '#SIREN', '#LegalStatus', '#LegalKind', '#LegalChief']
              // let tabResult = ['#resultSIREN', '#resultLegalStatus', '#resultLegalKind', '#resultLegalChief']
              for (var key in tabGblTargetBlock) {
                let item = that.$$(tabGblTargetBlock[key])
                if (!item.hasClass('verifHidden')) {
                  item.addClass('verifHidden')
                }
              }
              for (var tkey in tabTarget) {
                let titem = that.$$(tabTarget[tkey])
                if (titem.hasClass('verifHidden')) {
                  titem.removeClass('verifHidden')
                }
              }
              console.log(response.data)
            }
          })
          .catch(error => {
            that.$f7.hidePreloader()
            for (var key in tabGblTargetBlock) {
              let item = that.$$(tabGblTargetBlock[key])
              if (!item.hasClass('verifHidden')) {
                item.addClass('verifHidden')
              }
            }
            errorMessageAlert(error, that)
          })
          break
        case 'Actes':
          that.$engine.services.verifications.ACTES({'Actes': that.actes})
          .then(response => {
            that.status = response.status
            if (response.status === 200) {
              that.$f7.hidePreloader()
              let tabTarget = ['#resultBlock', '#SIREN', '#LegalStatus', '#LegalKind', '#LegalChief']
              // let tabResult = ['#resultSIREN', '#resultLegalStatus', '#resultLegalKind', '#resultLegalChief']
              for (var key in tabGblTargetBlock) {
                let item = that.$$(tabGblTargetBlock[key])
                if (!item.hasClass('verifHidden')) {
                  item.addClass('verifHidden')
                }
              }
              for (var tkey in tabTarget) {
                let titem = that.$$(tabTarget[tkey])
                if (titem.hasClass('verifHidden')) {
                  titem.removeClass('verifHidden')
                }
              }
              console.log(response.data)
            }
          })
          .catch(error => {
            that.$f7.hidePreloader()
            for (var key in tabGblTargetBlock) {
              let item = that.$$(tabGblTargetBlock[key])
              if (!item.hasClass('verifHidden')) {
                item.addClass('verifHidden')
              }
            }
            errorMessageAlert(error, that)
          })
          break
        case 'Ubo':
          that.$engine.services.verifications.UBO({'Ubo': that.ubo})
          .then(response => {
            that.status = response.status
            if (response.status === 200) {
              that.$f7.hidePreloader()
              let tabTarget = ['#resultBlock', '#SIREN', '#LegalStatus', '#LegalKind', '#LegalChief']
              // let tabResult = ['#resultSIREN', '#resultLegalStatus', '#resultLegalKind', '#resultLegalChief']
              for (var key in tabGblTargetBlock) {
                let item = that.$$(tabGblTargetBlock[key])
                if (!item.hasClass('verifHidden')) {
                  item.addClass('verifHidden')
                }
              }
              for (var tkey in tabTarget) {
                let titem = that.$$(tabTarget[tkey])
                if (titem.hasClass('verifHidden')) {
                  titem.removeClass('verifHidden')
                }
              }
              console.log(response.data)
            }
          })
          .catch(error => {
            that.$f7.hidePreloader()
            for (var key in tabGblTargetBlock) {
              let item = that.$$(tabGblTargetBlock[key])
              if (!item.hasClass('verifHidden')) {
                item.addClass('verifHidden')
              }
            }
            errorMessageAlert(error, that)
          })
          break
      }
      this.$f7.hidePreloader()
    },
    checkVerifType () {
      console.log('selected ' + this.verifTypeSelected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// VerificationsForm.vue?4ea7e8fa